import { useState, useEffect } from 'react';

const SIZE_MAP: Record<string, number> = {
  'Valor da viagem': 250,
  'Valor da viagem - revise': 330,
  IOF: 0,
  'Taxa de juros': 0,
  'Valor da entrada': 340,
  'Custo efetivo total': 0,
  'Taxa cadastral': 0,
  'Primeiro vencimento': 340,
  'Primeiro vencimento - revise': 375,
  'Próximos vencimentos': 340,
  'Próximos vencimentos - revise': 375,
  'Quantidade de parcelas': 520,
  Para: 465,
  Parcelas: 340,
  'Parcelas - revise': 400,
  Total: 0,
};

type UseResponsiveFlexProps = {
  label: string;
  revise?: boolean;
  customSize?: number;
};

export const useResponsiveFlex = ({
  label,
  revise,
  customSize,
}: UseResponsiveFlexProps) => {
  const isBreack = [381, 441, 701, 1025, 1281, 1441, 1921].includes(
    window.innerWidth
  );

  const targetWidth =
    customSize ?? SIZE_MAP[label + (revise ? ' - revise' : '')] ?? 0;

  const [isRow, setIsRow] = useState(window.innerWidth >= targetWidth);

  useEffect(() => {
    const handleResize = () => setIsRow(window.innerWidth >= targetWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [targetWidth, isBreack]);

  return isRow ? 'flex-row' : 'flex-col';
};

export const useWindowWidth = (targetWidth: number) => {
  const [isExactWidth, setIsExactWidth] = useState(
    window.innerWidth >= targetWidth
  );

  useEffect(() => {
    const handleResize = () => {
      setIsExactWidth(window.innerWidth >= targetWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [targetWidth]);

  return isExactWidth;
};
